var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-list',{attrs:{"fileType":2,"fileList":_vm.fileList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }